import { createSelector, Selector } from 'reselect';

import { RootState } from 'app/redux/createRootReducer';

export default function subSelectorCreator<SubState>(
  storeSelector: (state: RootState) => SubState
) {
  return function createSubSelector<R>(subSelector: Selector<SubState, R>) {
    return createSelector(storeSelector, subSelector);
  };
}
